$(window.document).ready(function (e) {
    $('#form-consulenza-mutuo, #form-consulenza-mutuo-modal').submit(function(event) {
        event.preventDefault();
        var form = $(this);
        var text = '';
        var forminfo = (form.attr('id') == 'form-consulenza-mutuo-modal') ? '-modal' : '';

        if (form.valid()) {
            overlay.fadeIn(function () {
                $.ajax({
                    url: '/sendMail',
                    type: 'POST',
                    dataType: 'json',
                    data: form.serialize(),
                })
                .done(function(data) {
                    //data = JSON.parse(data);
                    if(data.redirectUrl){
                        setTimeout(function(){
                            window.location.href=data.redirectUrl;
                        });
                    }
                    else{
                        var aMes = data.split('|');
                        var check = aMes[0];
                        var sMes =  aMes[1];
                        if(check=='ok'){
                            form['0'].reset();
                        }
                        $('#infoForm'+ forminfo).fadeIn('slow');
                        $('#infoForm'+ forminfo).html(sMes);
                        setTimeout(function(){
                            $('#infoForm' + forminfo).fadeOut('slow', function() {
                                $('#infoForm' + forminfo).html('');
                                if (form.attr('id') == 'form-consulenza-mutuo-modal') {
                                    $('#modal-contatti').modal('hide');
                                }
                            });
                        },7000);
                    }

                })
                .fail(function(e) {
                    if (e.status == 422) {
                        $('#form-consulenza-mutuo label.error').remove();
                        $('#form-consulenza-mutuo .errors').remove();
                        $('#form-consulenza-mutuo input').removeClass('error');
                        var errori = e.responseJSON;
                        $.each(errori, function(index, val) {
                            var eError = $('#error-consulenza-' + index);
                            if(eError.length<1){
                                //input diventa rossa
                                $('#'+index).addClass("error");
                                $('<div class="errors col-md-12" id="error-consulenza-'+index+'"></div>').insertAfter($('#'+index));
                                eError = $('#error-consulenza-' + index);
                                
                            }
                            eError.html(val[0]);
                        });
                    }
                    text = oLang.errori[e.status];
                })
                .always(function(){
                    overlay.fadeOut();
                });
            });
        }
    });
});
